
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4520009f&scoped=true!sass-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Index.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Index.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4520009f!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Index.vue"),
  /* scopeId */
  "data-v-4520009f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/plexHeader/userCenterHeader/Index.vue
// module id = 1165
// module chunks = 1